import type { ApiProblemTopic, LearnPostSummary } from '@/api/types';

/** O'zbekcha tutuq belgisining barcha yozilishi bitta belgiga keladi (o'zgaruvchi, oʻzgaruvchi). */
function normalize(text: string): string {
  return text.toLowerCase().replace(/[’‘ʻʼ`]/g, "'");
}

/** Har bir so'z sarlavha yoki tavsifda (istalgan tilda) bo'lishi kerak. */
export function matchesSearch(post: LearnPostSummary, query: string): boolean {
  const words = normalize(query).split(/\s+/).filter(Boolean);
  if (words.length === 0) return true;
  const text = normalize(
    [post.title, post.summary, post.titleRu, post.summaryRu, post.titleEn, post.summaryEn].filter(Boolean).join(' '),
  );
  return words.every((word) => text.includes(word));
}

/** API dagi mavzu ichidagi tartib bilan bir xil: pozitsiya, keyin nashr sanasi. */
function byTopicOrder(a: LearnPostSummary, b: LearnPostSummary): number {
  return (
    (a.topicPosition ?? 0) - (b.topicPosition ?? 0) ||
    (a.publishedAt ?? '9999').localeCompare(b.publishedAt ?? '9999')
  );
}

export function postsOfTopic(posts: LearnPostSummary[], topic: ApiProblemTopic | null): LearnPostSummary[] {
  return posts.filter((p) => (p.topic ?? null) === topic).sort(byTopicOrder);
}
